import { Nav, Footer } from "./components/components";
import { Blog, Home, Project } from "./pages/pages";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from 'framer-motion'
import "./App.css";

function App() {

  return (
    <div className="App">
      <Nav />
      <AnimatePresence mode='wait'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="project"
            element={<Project />}
          />
          <Route path="blog" element={<Blog />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div >
  );
}

export default App;
